import React from "react";
import Icon from "../../../components/Icon";
import ImageDropField from "./ImageDropField";
import { LANGS } from "../shared";
import styles from "./SectionsEditor.module.sass";

const emptySection = () => ({
  title: LANGS.reduce((acc, l) => ({ ...acc, [l]: "" }), {}),
  body: LANGS.reduce((acc, l) => ({ ...acc, [l]: "" }), {}),
  imageUrl: "",
});

/**
 * SECCIONES del correo de Bāo (template="bao"): bloques numerados con titular,
 * párrafo y captura. Estructura compartida entre idiomas, texto por idioma —
 * igual que el editor de bloques.
 */
const SectionsEditor = ({ sections, onChange, lang, disabled, onNotify }) => {
  const update = (index, patch) =>
    onChange(sections.map((s, i) => (i === index ? { ...s, ...patch } : s)));

  const move = (index, delta) => {
    const next = [...sections];
    const target = index + delta;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <div className={styles.title}>Secciones del correo</div>
        <div className={styles.hint}>Bloques numerados con captura. Solo los usa la plantilla de Bāo.</div>
      </div>

      {sections.map((section, index) => (
        <div className={styles.section} key={index}>
          <div className={styles.num}>{index + 1}</div>
          <div className={styles.fields}>
            <input
              className={styles.input}
              placeholder={`Titular (${lang.toUpperCase()})`}
              value={section.title?.[lang] || ""}
              disabled={disabled}
              onChange={(e) =>
                update(index, { title: { ...section.title, [lang]: e.target.value } })
              }
            />
            <textarea
              className={styles.textarea}
              rows={3}
              placeholder={`Texto (${lang.toUpperCase()})`}
              value={section.body?.[lang] || ""}
              disabled={disabled}
              onChange={(e) =>
                update(index, { body: { ...section.body, [lang]: e.target.value } })
              }
            />
            <ImageDropField
              value={section.imageUrl || ""}
              onChange={(url) => update(index, { imageUrl: url })}
              disabled={disabled}
              onNotify={onNotify}
            />
          </div>
          {section.imageUrl && (
            <img className={styles.thumb} src={section.imageUrl} alt="" />
          )}
          {!disabled && (
            <div className={styles.actions}>
              <button type="button" className={styles.action} onClick={() => move(index, -1)}>
                <Icon name="arrow-top" size="16" />
              </button>
              <button type="button" className={styles.action} onClick={() => move(index, 1)}>
                <Icon name="arrow-bottom" size="16" />
              </button>
              <button
                type="button"
                className={styles.action}
                onClick={() => onChange(sections.filter((_, i) => i !== index))}
              >
                <Icon name="trash" size="16" />
              </button>
            </div>
          )}
        </div>
      ))}

      {!disabled && (
        <button
          type="button"
          className={styles.add}
          onClick={() => onChange([...sections, emptySection()])}
        >
          + Añadir sección
        </button>
      )}
    </div>
  );
};

export default SectionsEditor;
